<script setup>
// Props
defineProps({
  homeLink: {
    type: String,
    default: '/'
  }
})
</script>

<!-- -------------------------------------------------------------------------------------------------
    Template
------------------------------------------------------------------------------------------------- -->

<template>
<a :href="homeLink" class="logo" aria-label="Home">
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" aria-hidden="true">
    <path d="M18.2188 13.7813H32V18.2188H21.3571L28.8828 25.7444L25.7455 28.8828L18.2188 21.3549V32H13.7813V21.356L6.25558 28.8828L3.11719 25.7455L10.644 18.2188H0V13.7813H10.6451L3.1183 6.25446L6.25558 3.11719L13.7813 10.6429V0H18.2188V13.7813Z" fill="black"/>
    <path d="M28.3254 6.46697C28.3254 8.03578 27.0536 9.30755 25.4848 9.30755C23.916 9.30755 22.6443 8.03578 22.6443 6.46697C22.6443 4.89817 23.916 3.6264 25.4848 3.6264C27.0536 3.6264 28.3254 4.89817 28.3254 6.46697Z" fill="black"/>
  </svg>
</a>
</template>

<!-- -------------------------------------------------------------------------------------------------
    Styling
------------------------------------------------------------------------------------------------- -->

<style scoped>
.logo {
  position: relative;
  display: flex;
  align-items: center;
  height: 72px;
}
</style>
